import React from "react";
import './SkinAssessmentErrorModal.scss';

const SkinAssessmentErrorModal = ({
    isOpen,
    title = '',
    message = '',
    buttons = [],
    onClose
}) => {
    if (!isOpen) return null;

    return (
        <div className="assessment-backdrop">
            <div className="assessment-wrapper">

                <div className="assessment-header">
                    <span>{title}</span>
                    {onClose && <button onClick={onClose}>✕</button>}
                </div>

                <div className="assessment-card">
                    <p className="assessment-message">
                        {message}
                    </p>

                    <div
                        className={`assessment-actions ${buttons.length === 1 ? 'single' : 'double'
                            }`}
                    >
                        {buttons.map((btn, i) => (
                            <button
                                key={i}
                                className={`assessment-btn ${btn.variant}`}
                                onClick={btn.onClick}
                            >
                                {btn.label}
                            </button>
                        ))}
                    </div>
                </div>

            </div>
        </div>
    );
};

export default SkinAssessmentErrorModal;